import enBase from "./locales/en.json";
import { managerDashboardResources } from "./locales/managerDashboard";
import { invoiceSellerResources } from "./locales/invoiceSeller";
import { groupLabelResources } from "./locales/groupLabels";
import { administrationScopeResources } from "./locales/administrationScope";
import { roomAdministrationResources } from "./locales/roomAdministration";
import { reservationWizardResources } from "./locales/reservationWizard";
import { pmsOperationsResources } from "./locales/pmsOperations";
import { nightAuditResources } from "./locales/nightAudit";
import { reportingResources } from "./locales/reporting";
import { groupOperationsResources } from "./locales/groupOperations";
import { groupWorkspaceResources } from "./locales/groupWorkspace";
import { parkingResources } from "./locales/parking";
import { posSalesResources, posSalesAdditions } from "./locales/posSales";
import { posOperationsResources } from "./locales/posOperations";
import { posBillingResources } from "./locales/posBilling";
import { posPaymentResources } from "./locales/posPayments";
import { posReportingResources } from "./locales/posReporting";
import { posAuditResources } from "./locales/posAudit";
import { identityUiResources } from "./locales/identityUi";
import { surveysResources } from "./locales/surveys";
import { emsResources } from "./locales/ems";
import { voipResources } from "./locales/voip";
import { wmsResources } from "./locales/wms";
import { pmsInvoiceResources } from "./locales/pmsInvoices";
import { hotelSettingsResources } from "./locales/hotelSettings";
import { pmsTaxSettingsResources } from "./locales/pmsTaxSettings";
import { posAdminResources, posAdminAdditions } from "./locales/posAdmin";
import deBase from "./locales/de.json";
import plBase from "./locales/pl.json";
import frBase from "./locales/fr.json";
import enPmsBilling from "../languages/en/en_pms_billing";
import enPmsChannelManager from "../languages/en/en_pms_channel_manager";
import enPmsCheckinStay from "../languages/en/en_pms_checkin_stay";
import enPmsCommon from "../languages/en/en_pms_common";
import enPmsGroups from "../languages/en/en_pms_groups";
import enPmsGuests from "../languages/en/en_pms_guests"; 
import enPmsHousekeeping from "../languages/en/en_pms_housekeeping";
import enPmsLiveBoard from "../languages/en/en_pms_live_board";
import enPmsManagerDashboard from "../languages/en/en_pms_manager_dashboard";
import enPmsNightAudit from "../languages/en/en_pms_night_audit";
import enPmsPersonalDashboard from "../languages/en/en_pms_personal_dashboard";
import enPmsReservations from "../languages/en/en_pms_reservations";
import enPmsRevenue from "../languages/en/en_pms_revenue";
import enPmsReports from "../languages/en/en_pms_reports";
import enPos from "../languages/en/en_pos";
import enCctv from "../languages/en/en_cctv";
import deCctv from "../languages/de/de_cctv";
import plCctv from "../languages/pl/pl_cctv";
import dePmsBilling from "../languages/de/de_pms_billing";
import dePmsChannelManager from "../languages/de/de_pms_channel_manager";
import dePmsCheckinStay from "../languages/de/de_pms_checkin_stay";
import dePmsCommon from "../languages/de/de_pms_common";
import dePmsGroups from "../languages/de/de_pms_groups"; 
import dePmsGuests from "../languages/de/de_pms_guests";
import dePmsHousekeeping from "../languages/de/de_pms_housekeeping";
import dePmsLiveBoard from "../languages/de/de_pms_live_board";
import dePmsManagerDashboard from "../languages/de/de_pms_manager_dashboard";
import dePmsNightAudit from "../languages/de/de_pms_night_audit";
import dePmsPersonalDashboard from "../languages/de/de_pms_personal_dashboard";
import dePmsReservations from "../languages/de/de_pms_reservations";
import dePmsRevenue from "../languages/de/de_pms_revenue";
import dePmsReports from "../languages/de/de_pms_reports";
import dePos from "../languages/de/de_pos";
import plPmsBilling from "../languages/pl/pl_pms_billing";
import plPmsChannelManager from "../languages/pl/pl_pms_channel_manager";
import plPmsCheckinStay from "../languages/pl/pl_pms_checkin_stay";
import plPmsCommon from "../languages/pl/pl_pms_common";
import plPmsGroups from "../languages/pl/pl_pms_groups";
import plPmsGuests from "../languages/pl/pl_pms_guests";
import plPmsHousekeeping from "../languages/pl/pl_pms_housekeeping";
import plPmsLiveBoard from "../languages/pl/pl_pms_live_board";
import plPmsManagerDashboard from "../languages/pl/pl_pms_manager_dashboard";
import plPmsNightAudit from "../languages/pl/pl_pms_night_audit";
import plPmsPersonalDashboard from "../languages/pl/pl_pms_personal_dashboard";
import plPmsReservations from "../languages/pl/pl_pms_reservations";
import plPmsRevenue from "../languages/pl/pl_pms_revenue";
import plPmsReports from "../languages/pl/pl_pms_reports";
import plPos from "../languages/pl/pl_pos";
import frPmsBilling from "../languages/fr/fr_pms_billing";
import frPmsChannelManager from "../languages/fr/fr_pms_channel_manager";
import frPmsCheckinStay from "../languages/fr/fr_pms_checkin_stay";
import frPmsCommon from "../languages/fr/fr_pms_common";
import frPmsGroups from "../languages/fr/fr_pms_groups";
import frPmsGuests from "../languages/fr/fr_pms_guests";
import frPmsHousekeeping from "../languages/fr/fr_pms_housekeeping";
import frPmsLiveBoard from "../languages/fr/fr_pms_live_board";
import frPmsManagerDashboard from "../languages/fr/fr_pms_manager_dashboard";
import frPmsNightAudit from "../languages/fr/fr_pms_night_audit";
import frPmsPersonalDashboard from "../languages/fr/fr_pms_personal_dashboard";
import frPmsReservations from "../languages/fr/fr_pms_reservations";
import frPmsRevenue from "../languages/fr/fr_pms_revenue";
import frPmsReports from "../languages/fr/fr_pms_reports";

type TranslationTree = Record<string, unknown>;

function isPlainObject(value: unknown): value is TranslationTree {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function deepMerge<T extends TranslationTree>(base: T, ...overrides: TranslationTree[]): T {
  const output: TranslationTree = { ...base };

  for (const override of overrides) {
    for (const [key, value] of Object.entries(override)) {
      const current = output[key];
      if (isPlainObject(current) && isPlainObject(value)) {
        output[key] = deepMerge(current, value);
        continue;
      }
      output[key] = value;
    }
  }

  return output as T;
}

function buildPmsResource(parts: {
  common: TranslationTree;
  billing: TranslationTree;
  channelManager: TranslationTree;
  checkinStay: TranslationTree;
  groups: TranslationTree;
  guests: TranslationTree;
  housekeeping: TranslationTree;
  liveBoard: TranslationTree;
  managerDashboard: TranslationTree;
  nightAudit: TranslationTree;
  personalDashboard: TranslationTree;
  reservations: TranslationTree;
  revenue: TranslationTree;
  reports: TranslationTree;
}) {
  return {
    pms: {
      common: parts.common,
      billing: parts.billing,
      channelManager: parts.channelManager,
      checkinStay: parts.checkinStay,
      groups: parts.groups,
      guests: parts.guests,
      housekeeping: parts.housekeeping,
      liveBoard: parts.liveBoard,
      managerDashboard: parts.managerDashboard,
      nightAudit: parts.nightAudit,
      personalDashboard: parts.personalDashboard,
      reservations: parts.reservations,
      revenue: parts.revenue,
      reports: parts.reports,
    },
  };
}

const sharedEnglish = {
  modules: {
    "identity-management": { title: "Identity Management", subtitle: "Manage user identities and access" },
    "parking-preview": { title: "Parking Preview", subtitle: "Local parking UX prototype" },
  },
  language: {
    de: "German",
    en: "English",
    pl: "Polish",
    fr: "French",
  },
};

const sharedGerman = {
  modules: {
    "identity-management": { title: "Identitätsverwaltung", subtitle: "Benutzeridentitäten und Zugriff verwalten" },
    "parking-preview": { title: "Parkplatzvorschau", subtitle: "Lokaler Prototyp der Parkplatzoberfläche" },
  },
  language: {
    de: "Deutsch",
    en: "Englisch",
    pl: "Polnisch",
    fr: "Französisch",
  },
};

const sharedPolish = {
  modules: {
    pms: { title: "PMS", subtitle: "Zarządzanie rezerwacjami, pobytami i recepcją" },
    identity: { title: "Zarządzanie użytkownikami", subtitle: "Użytkownicy, role i uprawnienia" },
    "identity-management": { title: "Zarządzanie tożsamością", subtitle: "Zarządzanie kontami i dostępem" },
    settings: { title: "Ustawienia", subtitle: "Ustawienia systemu, wyglądu i języka" },
    pos: { title: "POS", subtitle: "Sprzedaż, płatności i obsługa punktów sprzedaży" },
    ems: { title: "EMS", subtitle: "Konserwacja, wyposażenie i zlecenia techniczne" },
    voip: { title: "VoIP", subtitle: "Połączenia, operatorzy i obsługa telefonu" },
    wms: { title: "WMS", subtitle: "Stany magazynowe i ruch towarów" },
    revenue: { title: "Zarządzanie przychodami", subtitle: "Ceny, popyt i strategia cenowa" },
    guests: { title: "Goście", subtitle: "Profile, historia i preferencje gości" },
    cctv: { title: "CCTV", subtitle: "Centrum monitoringu" },
    support: { title: "Pomoc", subtitle: "Portal pomocy Jira (otwiera się w nowej karcie)" },
    keycoder: { title: "Keycoder", subtitle: "Kontrola dostępu" },
    garage: { title: "Parking", subtitle: "Zarządzanie parkingiem" },
    "parking-preview": { title: "Podgląd parkingu", subtitle: "Lokalny prototyp widoku parkingu" },
    feedback: { title: "Feedback", subtitle: "Powiedz zespołowi Xentros, co myślisz o aplikacji" },
  },
  language: {
    de: "Niemiecki",
    en: "Angielski",
    pl: "Polski",
    fr: "Francuski",
  },
  identity: {
    all_properties: "Wszystkie obiekty",
    property: "Obiekt",
  },
  auth: {
    access_denied_title: "Brak dostępu",
    access_denied_text: "Nie masz uprawnień do otwarcia tego obszaru w Xentros HOS.",
    welcome_back: "Witamy ponownie",
    sign_in_subtitle: "Zaloguj się przy użyciu danych administratora, aby kontynuować.",
    username: "Nazwa użytkownika",
    password: "Hasło",
    login_placeholder: "Login",
    login: "Zaloguj się",
    change_language: "Zmień język",
    show_password: "Pokaż hasło",
    hide_password: "Ukryj hasło",
    signing_in: "Logowanie...",
    username_required: "Wpisz nazwę użytkownika.",
    password_required: "Wpisz hasło.",
    server_unavailable: "Nie można połączyć się z serwerem logowania. Spróbuj ponownie.",
    session_failed: "Nie udało się dokończyć logowania. Spróbuj ponownie.",
    account_inactive: "Konto jest nieaktywne. Skontaktuj się z administratorem.",
    no_role_assigned_text: "Konto jest uwierzytelnione, ale nie ma jeszcze przypisanej roli w Xentros.",
    invalid: "Nieprawidłowe dane logowania lub kod.",
  },
  hos_dashboard: {
    alerts: {
      title: "Alerty",
      empty: "Wszystko w porządku — obecnie brak alertów",
      view_all: "Wyświetl wszystkie alerty ({{count}}) ›",
      dialog_label: "Wszystkie alerty",
      count_one: "{{count}} alert",
      count_few: "{{count}} alerty",
      count_many: "{{count}} alertów",
      count_other: "{{count}} alertu",
      close: "Zamknij",
      open_reservation: "Otwórz rezerwację",
      open_room: "Otwórz pokój",
    },
  },
};

const sharedFrench = {
  language: {
    de: "Allemand",
    en: "Anglais",
    pl: "Polonais",
    fr: "Francais",
  },
  identity: {
    all_properties: "Tous les établissements",
    property: "Établissement",
  },
  auth: {
    welcome_back: "Bienvenue",
    sign_in_subtitle: "Connectez-vous avec vos identifiants administrateur pour continuer.",
    username: "Nom d’utilisateur",
    password: "Mot de passe",
    login_placeholder: "Identifiant",
    login: "Connexion",
    change_language: "Changer de langue",
    show_password: "Afficher le mot de passe",
    hide_password: "Masquer le mot de passe",
    signing_in: "Connexion en cours...",
    invalid: "Identifiants ou code incorrects.",
  },
  hos_dashboard: {
    alerts: {
      title: "Alertes",
      empty: "Tout est en ordre — aucune alerte actuellement",
      view_all: "Afficher les {{count}} alertes ›",
      dialog_label: "Toutes les alertes",
      count_one: "{{count}} alerte",
      count_other: "{{count}} alertes",
      close: "Fermer",
    },
  },
};

export const translationResources = {
  en: {
    posAdminUi: {} as Record<string, string>,
    hotelSettingsUi: hotelSettingsResources.en,
    pmsTaxSettingsUi: pmsTaxSettingsResources.en,
    posSalesUi: posSalesResources.en,
    posOperationsUi: posOperationsResources.en,
    posBillingUi: posBillingResources.en,
    posPaymentUi: posPaymentResources.en,
    posReportingUi: posReportingResources.en,
    posAuditUi: posAuditResources.en,
    identityUi: identityUiResources.en,
    surveys: surveysResources.en,
    ems: emsResources.en,
    voip: voipResources.en,
    wms: wmsResources.en,
    pmsInvoices: pmsInvoiceResources.en,
    nightAuditUi: nightAuditResources.en,
    reportingUi: reportingResources.en,
    groupOperations: groupOperationsResources.en,
    groupWorkspace: groupWorkspaceResources.en,
    parkingUi: parkingResources.en,
    groupLabels: groupLabelResources.en,
    reservationWizard: reservationWizardResources.en,
    managerDashboardUi: managerDashboardResources.en,
    pmsOperations: pmsOperationsResources.en,
    translation: deepMerge(
      enBase as TranslationTree,
      sharedEnglish,
      { pos: { ...enPos, sales: { ...enPos.sales, ...posSalesAdditions.en } }, cctv: enCctv, administrationScope: administrationScopeResources.en, invoiceSeller: invoiceSellerResources.en },
      buildPmsResource({
        common: { ...enPmsCommon, roomAdmin: roomAdministrationResources.en },
        billing: enPmsBilling,
        channelManager: enPmsChannelManager,
        checkinStay: enPmsCheckinStay,
        groups: enPmsGroups,
        guests: enPmsGuests,
        housekeeping: enPmsHousekeeping,
        liveBoard: enPmsLiveBoard,
        managerDashboard: enPmsManagerDashboard,
        nightAudit: enPmsNightAudit,
        personalDashboard: enPmsPersonalDashboard,
        reservations: enPmsReservations,
        revenue: enPmsRevenue,
        reports: enPmsReports,
      }),
    ),
  },
  de: {
    posAdminUi: {} as Record<string, string>,
    hotelSettingsUi: hotelSettingsResources.de,
    pmsTaxSettingsUi: pmsTaxSettingsResources.de,
    posSalesUi: posSalesResources.de,
    posOperationsUi: posOperationsResources.de,
    posBillingUi: posBillingResources.de,
    posPaymentUi: posPaymentResources.de,
    posReportingUi: posReportingResources.de,
    posAuditUi: posAuditResources.de,
    identityUi: identityUiResources.de,
    surveys: surveysResources.de,
    ems: emsResources.de,
    voip: voipResources.de,
    wms: wmsResources.de,
    pmsInvoices: pmsInvoiceResources.de,
    nightAuditUi: nightAuditResources.de,
    reportingUi: reportingResources.de,
    groupOperations: groupOperationsResources.de,
    groupWorkspace: groupWorkspaceResources.de,
    parkingUi: parkingResources.de,
    groupLabels: groupLabelResources.de,
    reservationWizard: reservationWizardResources.de,
    managerDashboardUi: managerDashboardResources.de,
    pmsOperations: pmsOperationsResources.de,
    translation: deepMerge(
      deBase as TranslationTree,
      sharedGerman,
      { pos: { ...dePos, sales: { ...dePos.sales, ...posSalesAdditions.de } }, cctv: deCctv, administrationScope: administrationScopeResources.de, invoiceSeller: invoiceSellerResources.de },
      buildPmsResource({
        common: { ...dePmsCommon, roomAdmin: roomAdministrationResources.de },
        billing: dePmsBilling,
        channelManager: dePmsChannelManager,
        checkinStay: dePmsCheckinStay,
        groups: dePmsGroups,
        guests: dePmsGuests,
        housekeeping: dePmsHousekeeping,
        liveBoard: dePmsLiveBoard,
        managerDashboard: dePmsManagerDashboard,
        nightAudit: dePmsNightAudit,
        personalDashboard: dePmsPersonalDashboard,
        reservations: dePmsReservations,
        revenue: dePmsRevenue,
        reports: dePmsReports,
      }),
    ),
  },
  pl: {
    posAdminUi: {} as Record<string, string>,
    hotelSettingsUi: hotelSettingsResources.pl,
    pmsTaxSettingsUi: pmsTaxSettingsResources.pl,
    posSalesUi: posSalesResources.pl,
    posOperationsUi: posOperationsResources.pl,
    posBillingUi: posBillingResources.pl,
    posPaymentUi: posPaymentResources.pl,
    posReportingUi: posReportingResources.pl,
    posAuditUi: posAuditResources.pl,
    identityUi: identityUiResources.pl,
    surveys: surveysResources.pl,
    ems: emsResources.pl,
    voip: voipResources.pl,
    wms: wmsResources.pl,
    pmsInvoices: pmsInvoiceResources.pl,
    nightAuditUi: nightAuditResources.pl,
    reportingUi: reportingResources.pl,
    groupOperations: groupOperationsResources.pl,
    groupWorkspace: groupWorkspaceResources.pl,
    parkingUi: parkingResources.pl,
    groupLabels: groupLabelResources.pl,
    reservationWizard: reservationWizardResources.pl,
    managerDashboardUi: managerDashboardResources.pl,
    pmsOperations: pmsOperationsResources.pl,
    translation: deepMerge(
      enBase as TranslationTree,
      plBase as TranslationTree,
      sharedPolish,
      { pos: { ...plPos, sales: { ...plPos.sales, ...posSalesAdditions.pl } }, cctv: plCctv, administrationScope: administrationScopeResources.pl, invoiceSeller: invoiceSellerResources.pl },
      buildPmsResource({
        common: { ...plPmsCommon, roomAdmin: roomAdministrationResources.pl },
        billing: plPmsBilling,
        channelManager: plPmsChannelManager,
        checkinStay: plPmsCheckinStay,
        groups: plPmsGroups,
        guests: plPmsGuests,
        housekeeping: plPmsHousekeeping,
        liveBoard: plPmsLiveBoard,
        managerDashboard: plPmsManagerDashboard,
        nightAudit: plPmsNightAudit,
        personalDashboard: plPmsPersonalDashboard,
        reservations: plPmsReservations,
        revenue: plPmsRevenue,
        reports: plPmsReports,
      }),
    ),
  },
  fr: {
    reservationWizard: reservationWizardResources.en,
    pmsOperations: pmsOperationsResources.en,
    translation: deepMerge(
      enBase as TranslationTree,
      frBase as TranslationTree,
      sharedFrench,
      { pos: enPos },
      buildPmsResource({
        common: { ...frPmsCommon, roomAdmin: roomAdministrationResources.en },
        billing: frPmsBilling,
        channelManager: frPmsChannelManager,
        checkinStay: frPmsCheckinStay,
        groups: frPmsGroups,
        guests: frPmsGuests,
        housekeeping: frPmsHousekeeping,
        liveBoard: frPmsLiveBoard,
        managerDashboard: frPmsManagerDashboard,
        nightAudit: frPmsNightAudit,
        personalDashboard: frPmsPersonalDashboard,
        reservations: frPmsReservations,
        revenue: frPmsRevenue,
        reports: frPmsReports,
      }),
    ),
  },
} as const;

// Development generator input, captured before applying generated additions.
export const posAdminBaseResources = Object.fromEntries(
  (["en", "de", "pl"] as const).map(language => [language, {
    ...translationResources[language], posAdminUi: {},
    translation: { ...translationResources[language].translation },
  }]),
);

for (const language of ["en", "de", "pl"] as const) {
  Object.assign(translationResources[language].posAdminUi, posAdminResources[language]);
  Object.assign(translationResources[language].translation,
    deepMerge(translationResources[language].translation, posAdminAdditions[language]));
}
